import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const BackButton = ({ 
    text = "Back", 
    customPath = null, 
    style = {},
    className = ""
}) => {
    const navigate = useNavigate();

    const handleBack = () => {
        if (customPath) {
            navigate(customPath);
        } else {
            navigate(-1);
        }
    };

    const defaultStyle = {
        backgroundColor: 'transparent',
        border: '1px solid #0d5e9c',
        color: '#0d5e9c',
        padding: '8px 16px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '1rem',
        transition: 'all 0.3s ease',
        ...style
    };

    const hoverStyle = {
        backgroundColor: '#0d5e9c',
        color: 'white'
    };

    return (
        <button
            onClick={handleBack}
            className={className}
            style={defaultStyle}
            onMouseEnter={(e) => {
                e.target.style.backgroundColor = hoverStyle.backgroundColor;
                e.target.style.color = hoverStyle.color;
            }}
            onMouseLeave={(e) => {
                e.target.style.backgroundColor = defaultStyle.backgroundColor;
                e.target.style.color = defaultStyle.color;
            }}
        >
            <FontAwesomeIcon icon={faArrowLeft} />
            {text}
        </button>
    );
};

export default BackButton; 